import React, { useState, useEffect } from "react";
import ForkliftsEnquiryForm from "../components/ForkliftsEnquiryForm";
import EnquiryPopup from "../components/EnquiryPopup";
import ForkliftsCardComponent from "../components/ForkliftsCardComponent";
import AuthorizedDealers from "../components/AuthorizedDealers";
import ForkliftsNewHeroCarousel from "../components/ForkliftsNewHeroCarousel";
import ForkliftsWhyChoose from "../components/ForkliftsWhyChoose";
import ForkliftsProductsComponent from "../components/ForkliftsProductsComponent";
import ForkliftTabsComponent from "../components/ForkliftTabsComponent";
import { Link } from "react-router-dom";
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-fade';
import UnDieselSection from "../components/UnDieselForklifts";
import { fetchPhoneNumberInformation } from "../services/api";
import TopProducts from "../components/TopProducts";
const ForkliftsPage = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [phoneData, setPhoneData] = useState(null);
  const handleOpenPopup = () => {
    setIsPopupOpen(true);
  };
  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };
  useEffect(() => {
      const loadPhoneData = async () => {
        try {
          const data = await fetchPhoneNumberInformation();
          setPhoneData(data);
        } catch (error) {
          console.error('Error fetching phone number information:', error);
        }
      };
  
      loadPhoneData();
    }, []);

  return (
    <div>
      <AuthorizedDealers/>
      <ForkliftsNewHeroCarousel phoneData={phoneData} /> 
      <ForkliftsWhyChoose/>
      <section className="py-8 sm:py-16 bg-white">
                    <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
                      <div className="mb-8 lg:mb-8">
                    <h2 className="text-4xl sm:text-3xl lg:text-4xl xl:text-5xl font-normal text-gray-900">What’s <span className="font-bold">Special</span> about <span className="font-bold">UN</span>?</h2>
                  
                  </div>              
      <ForkliftsCardComponent/>
            
                    </div>
                  </section>

      <div
        className="py-8 sm:py-16 bg-neutral-50">
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
          <ForkliftsEnquiryForm
            title={
              <>
                Need the
                <br />
                <span className="font-semibold">Right Forklifts?</span>
              </>
            }
            content={
              <>
                <p className="text-xl lg:text-[22px] mb-8 text-white leading-relaxed">
                  Get <span className="font-semibold">expert advice</span>, <span className="font-semibold">quick quotes</span>, and the <span className="font-semibold">best deals</span> — all in
                  one place.
                </p>
                <p className="text-xl lg:text-[22px] mb-8 text-white leading-relaxed">
                  Enquire now and let{" "}
                  <span className="font-semibold">Golden Sparrow</span>
                  <br className="hidden sm:block" />
                  {' '}lift your business higher.
                </p>
              </>
            }
            backgroundImage="./images/forklifts/EnquiryForm.jpg"
            tagLine={<p className="text-center text-sm sm:text-sm italic text-black mt-6 sm:mt-12 max-w-xs sm:max-w-sm md:max-w-[300px] mx-auto px-2">Get Your Forklift Price Today – Response <span className="font-semibold">within 1 hour</span></p>}
          />
        </div>
      </div>

      {/* Bestselling Recommended Products Section Start Here  */}
      <section className="py-8 sm:py-16">
        <div className="max-w-7xl mx-auto px-6 sm:px-6 lg:px-8">
          <div className="recommended-products-header">
            <h2 className="recommended-products-title">
              <span className="recommended-products-title--bold">Bestselling Recommended</span> Products
            </h2>
            <div className="hidden sm:flex items-end">
              <img src="/images/logos/authorized_dealer_stamp_1.png" alt="Stamp" />
            </div>
          </div>
        <TopProducts productIds={['gs1365', 'gs1365', 'gs1365']} gridCols={{ sm: 3, lg: 3, xl: 3 }} />
        <div className='flex justify-center items-center'>
                    <Link to="/products?taxonomy=equipment-buy&term=forklifts&termName=Forklifts" className="font-semibold gradient-text">View more Listing <span className="chevronRight"></span></Link>
                  </div>
      </div>
      </section>

      {/* Bestselling Recommended Products Section End Here  */}
      <ForkliftTabsComponent />
      {/* Forklift banner section for desktop */}
      <section
        className="hidden sm:block fork-hero-section relative w-full bg-no-repeat py-8"
        role="banner"
        aria-label="Hero section"
      >
        <div
          className="absolute inset-0 w-full sm:w-[85%] md:w-[75%] lg:w-[65%] xl:w-[60%] h-full"
          style={{
            background:
              "linear-gradient(90deg, rgba(0, 0, 0, 0.95) 0%, rgba(0, 0, 0, 0.8) 45%, rgba(0, 0, 0, 0.4) 70%, rgba(0, 0, 0, 0) 100%)",
          }}
        ></div>
        <div className="relative max-w-7xl mx-auto px-6 sm:px-6 lg:px-8 xl:px-10 py-16 sm:py-20 md:py-24 lg:py-28 xl:py-24 h-full flex items-center">
          <div className="max-w-max">
            <h2 className="text-2xl md:text-5xl lg:text-5xl font-normal text-white leading-normal mb-6">
              UN Diesel Forklifts
            </h2>
            <p className="text-lg md:text-xl text-white font-semibold leading-relaxed mb-8">
              From warehouses to
              <br />
              construction and logistics.
            </p>

            <ul className="flex flex-col gap-2 mb-6">
              <li className="text-white">
                <p className="flex items-center gap-2 mb-1">
                  <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="w-4 text-black"
                    >
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </span>
                  <span className="font-semibold">Lift Up to 50 Tons</span>
                </p>
              </li>

              <li className="text-white">
                <p className="flex items-center gap-2 mb-1">
                  <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="w-4 text-black"
                    >
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </span>
                  <span className="font-semibold">
                    Trusted in 70+ countries
                  </span>
                </p>
              </li>

              <li className="text-white">
                <p className="flex items-center gap-2 mb-1">
                  <span className="bg-[#FFC501] rounded-full w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      className="w-4 text-black"
                    >
                      <path d="M5 12h14"></path>
                      <path d="m12 5 7 7-7 7"></path>
                    </svg>
                  </span>
                  <span className="font-semibold">
                    Fuel Efficient low running cost
                  </span>
                </p>
              </li>
            </ul>
          {phoneData?.acf?.phone_forklift && (
            <div className="flex flex-col sm:flex-row gap-4 mt-4">
              <a
                href={`tel:+${phoneData?.acf?.phone_forklift}`}
                className="quoteNowBtn inline-flex items-center justify-center gap-3 text-black font-bold text-sm sm:text-base md:text-lg px-6 sm:px-8 py-3 rounded-md focus:outline-none transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl" aria-label="Call to action button"
                style={{}}
              >
                <span><img
                  src="/images/icons/phone_black.png"
                  alt=""
                  width="20"
                  height="20"
                /></span>
                <span>Get Quote Now</span>
              </a>
            </div>
            )}
          </div>
        </div>
        <style jsx>{`
          .fork-hero-section {
            background-image: url("./images/forklifts/forklift_banner_new.png");
            background-position: center center;
            background-size: cover;
            background-repeat: no-repeat;
          }

          .quoteNowBtn {
            background: linear-gradient(
              159.21deg,
              #ffd200 11.19%,
              #f7971e 101.23%
            );
            outline: none;
            border: none;
          }

          .quoteNowBtn:hover,
          .quoteNowBtn:active {
            background: linear-gradient(
              159.21deg,
              #f7971e 11.19%,
              #ffd200 101.23%
            );
          }

          @media (max-width: 640px) {
            .fork-hero-section {
              background-position: center right;
            }
          }

          @media (min-width: 1920px) {
            .fork-hero-section {
              background-size: cover;
              background-position: right;
            }
          }
        `}</style>
      </section>

      {/* Forklift banner section for mobile */}
      <UnDieselSection phoneData={phoneData} />


      
      <EnquiryPopup isOpen={isPopupOpen} onClose={handleClosePopup} />
    </div>
  );
};
export default ForkliftsPage;
